exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FilterInput {\n    position: absolute;\n    left: 0;\n    top: 22px;\n    box-sizing: border-box;\n    width: 100%;\n    height: 24px;\n    font-weight: normal;\n    padding-left: 5px;\n}\n\n.FilterInput::placeholder {\n    color: #ddd;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/datatable/FilterInput.css
// module id = 1081
// module chunks = 0